/*
 * ap-klaviyo-subscribe.js — silky AJAX newsletter signup, site-wide.
 *
 * Intercepts every on-site newsletter form (any {% form 'customer' %} whose hidden
 * contact[tags] contains "newsletter": footer, newsletter section, About / Contact /
 * Blog / Article bands, email-signup banner). On submit it does NOT reload the page —
 * instead it:
 *   1) subscribes the email to Klaviyo via the public Client API (list Rrtwgd) so the
 *      Welcome flow fires instantly;
 *   2) posts the same form to Shopify in the background (so the subscriber still becomes
 *      a Shopify customer tagged "newsletter");
 *   3) smoothly reveals that form's OWN success message inline (each band keeps its own
 *      wording + styling).
 * If BOTH network calls fail, it falls back to the native full-page submit so nothing
 * is ever lost.
 *
 * Privacy / performance: first-party fetch() only — NO Klaviyo SDK / klaviyo.js, NO
 * tracking pixel, NO cookies. Public site ID only (safe in browser). Deferred + runs
 * only on submit → zero page-load impact. Keys/IDs managed in F:/Dawn/email.
 */
(function () {
  var PUBLIC_KEY = 'X8EW8S';   // Klaviyo site ID (public)
  var LIST_ID = 'Rrtwgd';      // "Email List"
  var REVISION = '2024-10-15';
  var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + PUBLIC_KEY;

  // Each form reuses its OWN success element (class + wording), so the inline "thanks"
  // looks identical to the server-rendered one. First match wins → specific before generic.
  var SUCCESS = [
    { key: 'ap-footer__newsletter-form',  cls: 'ap-footer__form-status ap-footer__form-status--ok', text: 'Thanks for subscribing' },
    { key: 'ap-about__newsletter-form',   cls: 'ap-about__newsletter-msg ap-about__newsletter-msg--ok', text: 'Welcome to the pack! Check your inbox.' },
    { key: 'ap-contact__newsletter-form', cls: 'ap-contact__newsletter-msg ap-contact__newsletter-msg--ok', text: 'Welcome to the pack! Check your inbox.' },
    { key: 'ap-blog__newsletter-form',    cls: 'ap-blog__newsletter-thanks', text: 'Thanks for subscribing! 🐾' },
    { key: 'newsletter-form',             cls: 'newsletter-form__message newsletter-form__message--success form__message', text: 'Thanks for subscribing' }
  ];

  function isNewsletterForm(form) {
    var tags = form.querySelector('input[name="contact[tags]"]');
    var email = form.querySelector('input[name="contact[email]"]');
    return !!(email && tags && /newsletter/i.test(tags.value || ''));
  }

  function resolveSuccess(form) {
    var name = ' ' + (form.className || '') + ' ';
    for (var i = 0; i < SUCCESS.length; i++) {
      if (name.indexOf(SUCCESS[i].key) !== -1) return SUCCESS[i];
    }
    return { cls: '', text: 'Thanks for subscribing' };
  }

  function klaviyoSubscribe(email, source) {
    return fetch(KLAVIYO_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website newsletter',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    });
  }

  // Background-submit the real Shopify customer form (same-origin → no CORS).
  function shopifyRegister(form) {
    return fetch(form.action || '/contact', { method: 'POST', body: new FormData(form) });
  }

  function showSuccess(form) {
    var spec = resolveSuccess(form);
    var msg = document.createElement('p');
    if (spec.cls) msg.className = spec.cls;
    msg.setAttribute('role', 'status');
    msg.textContent = spec.text;
    msg.style.opacity = '0';
    msg.style.transition = 'opacity .35s ease';
    // Hide the form's existing inputs/buttons, then reveal the message in their place.
    var kids = Array.prototype.slice.call(form.children);
    for (var i = 0; i < kids.length; i++) kids[i].style.display = 'none';
    form.appendChild(msg);
    requestAnimationFrame(function () { msg.style.opacity = '1'; });
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form instanceof HTMLFormElement) || !isNewsletterForm(form) || form.__apBusy) return;

    var input = form.querySelector('input[name="contact[email]"]');
    var email = input && (input.value || '').trim();
    if (!email) return; // empty → let native required-validation handle it

    // If onsite tracking (klaviyo.js) is loaded, tie this visitor's browsing to their
    // email so behavior flows (browse / cart abandonment) attribute correctly. Guarded.
    try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['identify', { '$email': email }]); } catch (e) {}

    // Take over: no page reload. On unexpected error we fall back to native submit.
    ev.preventDefault();
    form.__apBusy = true;
    var btn = form.querySelector('[type="submit"], button:not([type])');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    var src = (form.className || '').split(' ')[0] || 'Website newsletter';
    var resumed = false;
    var nativeFallback = function () {
      if (resumed) return; resumed = true;
      try { form.submit(); } catch (e) { form.__apBusy = false; }
    };
    var hardCap = setTimeout(function () {
      // If the network is wedged, don't hang the user — fall back to native submit.
      nativeFallback();
    }, 6000);

    var klaviyo = klaviyoSubscribe(email, src).then(function (r) { return r && r.ok; }).catch(function () { return false; });
    var shopify = shopifyRegister(form).then(function (r) { return !!r; }).catch(function () { return false; });

    Promise.all([klaviyo, shopify]).then(function (res) {
      clearTimeout(hardCap);
      if (resumed) return;
      if (res[0] || res[1]) {        // at least one path worked → silky success
        resumed = true;
        showSuccess(form);
      } else {                        // both failed → never lose the signup
        nativeFallback();
      }
    });
  }, true);
})();
